import { Column, Padding, Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import CustomIcon from "../../../common/components/image/CustomIcon";
import { C2Text, C3Text, T1Text, T3Text } from "../../../common/components/text/CustomText";
import Translate from "../../../common/translate/Translate";
import { Theme } from "../../../common/Theme";

function StatisticalAnalysisUsageCard({ height, type, mainValue, totalValue, washerValue, dryValue, comboValue }) {
    let iconSection;
    let typeTitle;

    if (type === "TotalDevice") {
        iconSection = (
            <SizedBox backgroundColor={Theme.color.indigo500_01} width={"40px"} height={"40px"} borderRadius={"100%"}>
                <CustomIcon iconName={"device"} size={"24px"} />
            </SizedBox>
        );
        typeTitle = Translate("revenue.deviceStatus.totalDevice");
    } else if (type === "ActiveDevice") {
        iconSection = (
            <SizedBox backgroundColor={Theme.color.teal500_01} width={"40px"} height={"40px"} borderRadius={"100%"}>
                <CustomIcon iconName={"activity"} size={"24px"} />
            </SizedBox>
        );
        typeTitle = Translate("revenue.deviceStatus.activeDevice");
    } else if (type === "NotAvailableDevice") {
        iconSection = (
            <SizedBox backgroundColor={Theme.color.rose500_01} width={"40px"} height={"40px"} borderRadius={"100%"}>
                <CustomIcon iconName={"blackout"} size={"24px"} />
            </SizedBox>
        );
        typeTitle = Translate("revenue.deviceStatus.notAvailableDevice");
    } else if (type === "FreeCycle") {
        iconSection = (
            <SizedBox backgroundColor={Theme.color.gray500_007} width={"40px"} height={"40px"} borderRadius={"100%"}>
                <CustomIcon iconName={"refresh_grey"} size={"24px"} />
            </SizedBox>
        );
        typeTitle = Translate("revenue.deviceStatus.freeCycle");
    }

    return (
        <SizedBox
            border={`1px solid ${Theme.color.gray250}`}
            borderRadius={"16px"}
            width={"100%"}
            height={height ?? "100%"}
            alignItem={"flex-start"}
            justifyContent={"flex-start"}
            padding={"16px"}
            backgroundColor={"transparent"}
        >
            {iconSection}
            <Row justifyContent={"space-between"} width={"100%"}>
                <Column justifyContent={"flex-start"} alignItem={"flex-start"}>
                    <SizedBox height={"32px"} />
                    <C2Text fontWeight={"500"}>{typeTitle}</C2Text>
                    <SizedBox height={"8px"} />
                    <Row alignItem={"center"}>
                        <T1Text>{mainValue}</T1Text>
                        <SizedBox width={"6px"} />
                        {(type === "ActiveDevice" || type === "NotAvailableDevice") && (
                            <T3Text fontColor={Theme.color.gray500}>/{totalValue}</T3Text>
                        )}
                        {type === "FreeCycle" && (
                            <Padding>
                                <C2Text fontColor={Theme.color.gray500}>cycle</C2Text>
                            </Padding>
                        )}
                    </Row>
                </Column>
                <SizedBox width={"16px"} />
                <Column justifyContent={"flex-end"} alignItem={"flex-end"} flex={"1"}>
                    <Row justifyContent={"space-between"} width={"100%"} alignItem={"flex-end"} maxWidth={"152px"}>
                        <Row justifyContent={"center"} alignItem={"center"}>
                            <CustomIcon iconName={"washer"} size={"16px"} />
                            <SizedBox width={"4px"} />
                            <Padding>
                                <C3Text fontColor={Theme.color.gray500}>{Translate("common.washer")}</C3Text>
                            </Padding>
                        </Row>
                        <Row justifyContent={"center"} alignItem={"center"}>
                            <Padding>
                                <C3Text fontWeight={"500"}>{washerValue}</C3Text>
                                <C3Text fontWeight={"500"} fontColor={Theme.color.gray500}>
                                    /{totalValue}
                                </C3Text>
                            </Padding>
                        </Row>
                    </Row>
                    <SizedBox height={"12px"} />
                    <Row justifyContent={"space-between"} width={"100%"} alignItem={"flex-end"} maxWidth={"152px"}>
                        <Row justifyContent={"center"} alignItem={"center"}>
                            <CustomIcon iconName={"dryer"} size={"16px"} />
                            <SizedBox width={"4px"} />
                            <Padding>
                                <C3Text fontColor={Theme.color.gray500}>{Translate("common.dryer")}</C3Text>
                            </Padding>
                        </Row>
                        <Row justifyContent={"center"} alignItem={"center"}>
                            <Padding>
                                <C3Text fontWeight={"500"}>{dryValue}</C3Text>
                                <C3Text fontWeight={"500"} fontColor={Theme.color.gray500}>
                                    /{totalValue}
                                </C3Text>
                            </Padding>
                        </Row>
                    </Row>
                    <SizedBox height={"12px"} />
                    <Row justifyContent={"space-between"} width={"100%"} alignItem={"flex-end"} maxWidth={"152px"}>
                        <Row justifyContent={"center"} alignItem={"center"}>
                            <CustomIcon iconName={"combo"} size={"16px"} />
                            <SizedBox width={"4px"} />
                            <Padding>
                                <C3Text fontColor={Theme.color.gray500}>{Translate("common.combo")}</C3Text>
                            </Padding>
                        </Row>
                        <Row justifyContent={"center"} alignItem={"center"}>
                            <Padding>
                                <C3Text fontWeight={"500"}>{comboValue}</C3Text>
                                <C3Text fontWeight={"500"} fontColor={Theme.color.gray500}>
                                    /{totalValue}
                                </C3Text>
                            </Padding>
                        </Row>
                    </Row>
                </Column>
            </Row>
        </SizedBox>
    );
}

export default StatisticalAnalysisUsageCard;
